import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-white border-t mt-0 py-4 text-center text-sm text-gray-600">
      <p>© {new Date().getFullYear()} CNC web world. All rights reserved.</p>
      <p>Contact: <a href="tel:+917400332999" className="text-indigo-600 hover:underline">+91 74003 32999</a> (Sanjay Navale)</p>
    </footer>
  );
}
